import { Button as MantineButton } from "@mantine/core";
import { createElement, type ReactNode } from "react";

import { resolveIcon } from "../icons";

type ButtonVariant = "default" | "filled" | "light" | "outline";

interface ButtonProps {
  children?: ReactNode;
  href?: string;
  icon?: string;
  variant?: ButtonVariant;
}

/**
 * Button renders the {% button %} tag as a Mantine `Button` rendered as an
 * anchor. External `http(s)` targets open in a new tab with
 * `rel="noopener noreferrer"`; an optional `icon` names a leading Nucleo glyph.
 */
export const Button = ({ children, href = "", icon, variant = "filled" }: ButtonProps) => {
  const isExternal = /^https?:\/\//.test(href);
  const Icon = resolveIcon(icon);

  return (
    <MantineButton
      component="a"
      href={href}
      leftSection={Icon ? createElement(Icon, { size: 16 }) : undefined}
      rel={isExternal ? "noopener noreferrer" : undefined}
      target={isExternal ? "_blank" : undefined}
      variant={variant}
    >
      {children}
    </MantineButton>
  );
};
